module.exports = __webpack_public_path__ + "static/img/s42.6370d8ad.png";